import React, { useState } from 'react';
import api from '../services/api';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    console.log('🚀 Login attempt started');
    console.log('📧 Credentials:', { username: credentials.username, password: '***' });

    try {
      console.log('📡 Sending login request...');
      const response = await api.login(credentials);
      console.log('✅ Login response received:', response);

      const { token, user } = response.data;
      console.log('🔑 Token received:', token ? 'YES' : 'NO');
      console.log('👤 User data:', user);

      onLogin(user, token);
      console.log('✅ Login successful');
    } catch (error) {
      console.error('❌ Login failed:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      console.error('❌ Error status:', error.response?.status);
      console.error('❌ Error data:', error.response?.data);

      setError(error.response?.data?.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', width: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a 
            href="https://nubemotic.com.ar" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ textDecoration: 'none' }}
            onMouseEnter={(e) => {
              e.currentTarget.querySelector('div').style.color = '#0096d6';
              e.currentTarget.querySelector('img').style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.querySelector('div').style.color = '#00aaff';
              e.currentTarget.querySelector('img').style.transform = 'scale(1)';
            }}
          >
            <img 
              src="/logo-designerlow.png" 
              alt="NubeMotic" 
              style={{ 
                height: '60px', 
                marginBottom: '0.5rem',
                display: 'block',
                margin: '0 auto',
                transition: 'transform 0.3s ease'
              }} 
            />
            <div style={{ 
              color: '#00aaff', 
              fontSize: '1.2rem', 
              fontWeight: 'bold',
              transition: 'color 0.3s ease'
            }}>
              IoT Integration
            </div>
          </a>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuario o Email"
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #ddd', borderRadius: '4px' }}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
            style={{ width: '100%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #ddd', borderRadius: '4px' }}
            required
          />
          {error && <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '0.75rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
